module.exports = __webpack_public_path__ + "static/media/veranda-login-banner1.e58a594f.jpg";